<template>
  <div class="home">
    <Header ref="height0" :hideUserIcon="true" :hideIpt="true" :bannerBg=3 />
    <div class="paddingBox">
      <div class="searchBox">
        <search2 @search="onSearch"></search2>
      </div>
      <div class="tabBox" ref="height2">
        <scrollTab v-if="fisrtLoad" :flexStyle="true" @choseTabItemCb="choseTabItemCb" :tabs="tabs"></scrollTab>
      </div>
      <van-list v-model="loading" :finished="finished" @load="getModuleList">
        <div class="listCard">
          <ul class="listCardBox">
            <li class="item" v-for="item in list" :key="item.id">
              <template v-if="curIndex == 0">
                <div class="prodCard"  @click="cardDisHandle(item)">
                  <div class="left">
                    <p class="t1 __line1">{{ item.material }} <span v-if="item.colour">（{{ item.colour }}）</span> </p>
                    <div class="tags">
                      <div class="tags_item" v-if="item?.kg">
                        {{ item.kg }}
                      </div>

                      <div class="tags_item" v-if="item?.silicon">
                        {{ item.silicon }}
                      </div>

                      <div class="tags_item" v-if="item?.force">
                        {{ item.force }}
                      </div>

                    </div>
                  </div>
                  <div class="right">
                    <img src="@/assets/images/common/RightOutline.png" alt="" srcset="">
                  </div>
                </div>
              </template>
              <template v-else-if="curIndex == 1">
                <div class="prodCard"  @click="cardDisHandle(item)">
                  <div class="left">
                    <p class="t1 __line1">{{ item.title }} <span v-if="item.colour">（{{ item.colour }}）</span> </p>
                    <p class="t2 __line2">{{ item.title_en }}</p>
                  </div>
                  <div class="right">
                    <img src="@/assets/images/common/RightOutline.png" alt="" srcset="">
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="imgCard" @click="modulePage(item)">
                  <div class="left">
                    <p class="t1 __line2">{{ item.title || '' }}</p>
                    <p class="t2 __line2">{{ item.description }}</p>
                  </div>
                  <div class="right">
                    <img :src="item.banner" alt="" srcset="">
                  </div>
                </div>
              </template>


            </li>
          </ul>
        </div>
      </van-list>

      <EmptyState :show="list.length == 0 && !loading" :emptyHeight="emptyHeight" :text="text" />

    </div>
    <div class="pdfWarp" v-show="showPdf">
      <div class="pdfWarpHeight">
        <div class="close" @click="togglePdf">
          <img src="@/assets/images/common/close.png" alt="" srcset="">
        </div>
        <div id="pdf-container"></div>
      </div>
    </div>
    <custom-modal :visible="showModal" :prodDisData="prodDisData" button-text="下载 TDS" @close="showModal = false"
      @tag-click="handleTagClick" @button-click="handleButtonClick" />
  </div>
</template>
    
<script>
import { Toast } from "vant";
import Crypt from "@bluedot-tech/vue-ui/es/utils/crypt";
import config from "../config/config";
import Header from "@/components/header";
import TabSwitcher from "@/components/TabSwitcher.vue";
import TypeCard from "@/components/typeCard.vue";
import search2 from "@/components/search2.vue";
import scrollTab from "@/components/scrollTab.vue";
import imgCard from "@/components/imgCard.vue";
import CustomModal from '@/components/prodPop.vue';
import EmptyState from '@/components/EmptyState.vue';
import PDFh5 from 'pdfh5';
import "pdfh5/css/pdfh5.css";
export default {
  components: {
    Header,
    TabSwitcher,
    TypeCard,
    search2,
    scrollTab,
    imgCard,
    CustomModal,
    EmptyState
  },
  data() {
    return {
      text: '暂无内容',
      text2: '暂无搜索结果',
      fisrtLoad: false,
      showPdf: false,
      prodDisData: null,
      showModal: false,
      tabs: ["产品", "解决方案", "成功案例", "离型知识"],
      curType: 0,
      params: [
        {
          type: 3,
          state: "",
        },
        {
          type: 3,
          state: 1,
          current: 1,
          s_type: "",
        },
      ],
      current: 1,
      curIndex: 0,
      apiList: ['/api/platform/product', '/api/platform/area', '/api/platform/cases', '/api/platform/cases'],
      query: null,
      list: [],
      keywords: '',
      total: 0,
      loading: false,
      finished: true,
      emptyHeight: 0,
      value: "",
      searchValue: "", // 父组件维护的搜索关键词
      imageList: [
        "https://br-education.oss-cn-beijing.aliyuncs.com/learning/20240620/rc-upload-1718862993329-3.jpeg",
        "https://br-education.oss-cn-beijing.aliyuncs.com/learning/20240620/rc-upload-1718862993329-3.jpeg",
        "https://br-education.oss-cn-beijing.aliyuncs.com/learning/20240620/rc-upload-1718862993329-3.jpeg",
        // 添加更多图片路径
      ],
    };
  },
  mounted() {
    this.query = this.$route.query;
    this.initShare();
    // 页面浏览 监测
    this.$dataStatistics({
      page_title: `全局搜索`,
    },'访问');
    this.calculateEmptyHeight();
  },

  methods: {
    onSearch(val, flag) {

      this.fisrtLoad = true;
      this.finished = false;

      if (val) {
        this.$dataStatistics('click', "搜索",{'page_param':{keywords:val}});
        this.text = this.text2;
      } else {
        this.text = "暂无内容"
      }

      this.keywords = val;

      this.reset();
      if (flag) {
        this.fisrtLoad = false;
        this.finished = true;
        this.loading = false;
        this.text = "暂无内容";
      }
      this.getModuleList();
    },
    togglePdf() {
      this.showPdf = !this.showPdf;
    },
    modulePage(item) {
      console.log('this.curIndex',this.curIndex)
      if (this.curIndex == 2) {
        this.$router.push(`/caseDis?id=${item.id}`);
      } else if (this.curIndex == 3) {
        this.$router.push(`/faqDis?id=${item.id}`);
      }

    },
    reset() {
      this.total = 0;
      this.list = [];
      this.current = 1;
      this.loading = true;
      this.finished = false;
    },
    updateTabHandle({ type }) {
      this.curType = type;
      this.reset();
    },
    choseTabItemCb({ index }) {
      if (this.curIndex == index) return;
      this.curIndex = index;
      this.reset();
      this.getModuleList();
    },
    calculateEmptyHeight() {
      this.$nextTick(() => {
        const headerHeight = this.$refs.height0.$el.offsetHeight;
        // const bannerHeight = this.$refs.height1.offsetHeight;
        const tabBoxHeight = this.$refs.height2.offsetHeight;
        const paddingBox = 180; // Padding value

        // Calculate remaining height
        const remainingHeight =
          window.innerHeight -
          headerHeight -
          tabBoxHeight -
          paddingBox;
        this.emptyHeight = remainingHeight > 0 ? remainingHeight : 0;
      });
    },
    onLoad() {
      let params = {
        'filter[type]': this.params[this.curType].type,
        'filter[state]': this.params[this.curType].state,
      }
      this.$http
        .get("/api/platform/type", { params: params })
        .then((res) => {
          this.list.push(...res.data.data);
          this.loading = false;
          this.finished = true;
        });
    },
    cardDisHandle(item) {
      if (this.curIndex == 0) {
        this.showModal = true;
        this.prodDisData = item;
      } else {
        this.$router.push(`/solutionDis?id=${item.id}`);
      }
    },
    async handleTagClick(tag) {
      console.log('Tag clicked:', tag, this.list);
      this.showModal = false;
      let list = await this.getTabList();
      let index = list.findIndex(item => tag.id == item.id);
      console.log('"index" ---:', index);

      this.$router.push(`/childList?tabId=${index}`)
    },
    async getTabList() {
      let params = {
        "filter[type]": 1,
      };
      let res = await this.$http.get("/api/platform/category", { params: params })
      return res.data;

      // this.getChild();
    },
    handleButtonClick(url) {
      console.log('Button clicked');
      this.userData(url);
    },
    userData(url) {
      if (!url) return Toast('暂无文件')
      console.log('"url" ---:', url);
      this.checkUser().then(res => {
        if (res.errcode == 1012) {
          this.$router.push('/MemberRegister')
        } else {
          this.pdfh5 = new PDFh5('#pdf-container', {
            pdfurl: url, // 替换为你的 PDF 文件路径
          });
          this.togglePdf();
        }
      })
    },
    checkUser() {
      return new Promise((resolve) => {
        let openid = this.$localStorage.getItem("openid");
        let params = { openid }
        this.$http.get("/api/platform/member/get-user-info", { params }).then((res) => {
          resolve(res.data);
        })
      });
    },

    getModuleList() {
      if (!this.fisrtLoad) return
      this.loading = true;
      if (this.list?.length < this.total) {
        this.current++;
      }
      let params = [{
        'filter[type]': '',
        // 'filter[state]': 1,
        'current': this.current,
        'filter[title]': this.keywords,
      }, {
        // 'filter[state]': 1,
        'current': this.current,
        'filter[title]': this.keywords,
      }, {
        // 'filter[state]': 1,
        'filter[s_type]': 2,
        'current': this.current,
        'filter[title]': this.keywords,
      }, {
        // 'filter[state]': 1,
        'filter[s_type]': 3,
        'current': this.current,
        'filter[title]': this.keywords,
      }]

      this.$http
        .get(this.apiList[this.curIndex], { params: params[this.curIndex] })
        .then((res) => {
          this.current = res?.data?.current;
          this.total = res?.data?.total;
          this.list = this.list.concat(res.data.data);
          this.$nextTick(() => {
            this.loading = false;
            if (this.list?.length >= this.total) {
              this.finished = true;
            }
          });
        });
    },
  },
};
</script>
<style lang="less" scoped>
.pdfWarp {
  padding: 20px;
  width: 100%;
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 11111;
  background: rgba(0, 0, 0, 0.6);

  .pdfWarpHeight {
    position: absolute;
    width: 90%;
    height: 80%;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
  }

  .close {
    position: absolute;
    right: 0px;
    top: -35px;
    width: 28px;
    height: 28px;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

#pdf-container {
  position: absolute;
  width: 100%;
  height: 100%;

  /deep/ .viewerContainer {
    width: 100% !important;
    height: 100% !important;
  }
}

.empty {
  width: 100%;

  .emptyImg {
    width: 120px;
    height: 144px;
    display: block;
  }
}

.home {
  position: relative;
  width: 100%;
  background: #FAFAFA;
  min-height: 100vh;

  .bannerContent {
    width: 100%;
    height: 394px;
    margin: 0 auto;
  }

  .tabBox {
    z-index: 2;
    position: sticky;
    top: 0;
    background: #FAFAFA;
  }

  .titleBox {
    font-size: 34px;
    color: #991d85;
    font-weight: bold;
    margin-top: 31px;

    .title {
      margin-left: 16px;
    }

    .line {
      width: 6px;
      height: 32px;
      background: #991d85;
      border-radius: 3px;
    }
  }

  .paddingBox {
    z-index: 1;
    position: relative;
    padding: 0 12px;
  }

  .searchBox {
    position: relative;
    margin-top: 9px;
  }

  .listCard {
    margin-top: 12px;
  }

  .bg {
    width: 200px;
    height: 200px;

    background-size: 100% 100%;
  }
}

.prodCard {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(270deg, #FFFFFF 0%, #FFFFFF 100%);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid;
  border-image: linear-gradient(270deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
  margin-bottom: 8px;

  .left {
    .t1 {
      font-size: 16px;
      color: #333333;
      line-height: 24px;
    }

    .t2 {
      font-size: 14px;
      color: #9F9F9F;
      line-height: 20px;
      margin-top: 8px;
    }
  }

  .right {
    width: 20px;
    height: 20px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.imgCard {
  word-break: break-all;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: linear-gradient(270deg, #FFFFFF 0%, #FFFFFF 100%);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid;
  border-image: linear-gradient(270deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)) 1 1;
  margin-bottom: 12px;

  .left {
    .t1 {
      font-size: 16px;
      color: #333333;
      line-height: 24px;
    }

    .t2 {
      font-size: 14px;
      color: #9F9F9F;
      line-height: 20px;
      margin-top: 4px;
    }
  }

  .right {
    width: 121px;
    height: 80px;
    border-radius: 4px 4px 4px 4px;
    flex-shrink: 0;
    margin-left: 16px;

    img {
      width: 100%;
      height: 100%;
      border-radius: 4px 4px 4px 4px;
    }
  }
}

.tags {
  display: flex;
  flex-wrap: wrap;

  .tags_item {
    font-size: 12px;
    color: #9F9F9F;
    padding: 4px 12px;
    background: #F3F3F3;
    border-radius: 4px 4px 4px 4px;
    margin-right: 5px;
    margin-top: 4px;
  }
}
</style>
    